import { render } from "./MainPreloader.vue?vue&type=template&id=3955a702&scoped=true"
import script from "./MainPreloader.vue?vue&type=script&lang=js"
export * from "./MainPreloader.vue?vue&type=script&lang=js"

import "./MainPreloader.vue?vue&type=style&index=0&id=3955a702&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3955a702"]])

export default __exports__